import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import FieldIconWrapper from 'common/components/form/FieldIconWrapper';

const FieldSelect = ({
  children,
  name = '',
  value = '',
  placeholder,
  autoFocus,
  inputSize,
  isLoading = false,
  handleChange = () => {},
  noEmptyOption = false,
  t,
  ...passThroughProps
}) => {
  return (
    <FieldIconWrapper {...passThroughProps}>
      <select
        className={classnames('form-control', {
          [`form-control-${inputSize}`]: !!inputSize,
          'is-invalid': passThroughProps.error && Object.keys(passThroughProps.error).length > 0,
        })}
        name={name}
        value={value}
        onChange={handleChange}
      >
        {isLoading && (
          <option value={''} disabled>
            {t('common.loading')}...
          </option>
        )}

        {!isLoading && !noEmptyOption && <option value={''}>{placeholder}</option>}
        {children}
      </select>
    </FieldIconWrapper>
  );
};

FieldSelect.propTypes = {
  value: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  error: PropTypes.object,
  handleChange: PropTypes.func,
  inputSize: PropTypes.oneOf(['lg', 'sm']),
  iconRight: PropTypes.string,
  iconLeft: PropTypes.string,
  iconRightSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconRightSpin: PropTypes.bool,
  iconLeftSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconLeftSpin: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default translate()(FieldSelect);



// WEBPACK FOOTER //
// src/modules/common/components/form/FieldSelect.js